import React, { useContext } from 'react';
import { SideNavigation, TopButton } from '../components';
import { SideNavContext } from '../contexts';
import Header from '../components/header/Header';
import Faq from '../components/support/Faq';
import Footer from '../components/footer/Footer';

const FaqPage = () => {

    const { isSideNavOpen } = useContext(SideNavContext);

    return (
        <>
            {isSideNavOpen && <SideNavigation />}

            <Header />

            <main>
                <Faq />
            </main>

            <Footer />

            <TopButton />
        </>
    );
};

export default FaqPage;